import { mergeDeepRight, reduce } from 'ramda';
import { FelaCSS } from '../components/fela/flowtypes';

const mergeStyles = (styles: object[]): FelaCSS => reduce(mergeDeepRight, {}, styles);

export default mergeStyles;
